import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import withRoot from "../withRoot";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import HomeNavButton from "../components/Layout/HomeNavButton";
import { createIconMap } from '../utils/routes';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 16,
    margin: 16
  },
  mainText: {
    color: theme.palette.primary.main
  },
});

class HomePage extends React.Component {

  render() {
    const { user, classes, routes } = this.props;

    return (
      <div className={classes.root}>
        <Grid container direction="column" spacing={16}>
          <Grid item xs>
            <Typography className={classes.mainText} variant="display1" gutterBottom>
              Wennstrom Control Panel - {user ? user.profile.identity_role : "Unknown"}
            </Typography>
          </Grid>
          <Grid item xs>
            <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={16}>
              {/* Slicing the first away, because it is HOME and it is not needed here */}
              {routes.slice(1).map((route) =>
                <Grid item xs={6} sm={4} md={3} lg={4} xl={1} key={route.name}>
                  <HomeNavButton title={route.name} routePath={route.path} Icon={findIcon(route.component)} />
                </Grid>)}
              </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function findIcon(componentName) {
  let iconMap = createIconMap();
  return iconMap.get(componentName);
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    routes: state.general.routes
  };
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(withRoot(withStyles(styles)(HomePage)));



// WEBPACK FOOTER //
// ./src/containers/HomePage.js